module.exports = __webpack_public_path__ + "img/Tour Rope.8f453058.jpg";